import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  color?: string;
  size?: number;
};
const QuestionMarkIcon: FC<Props> = ({ color = colors['--pink-500'], size = 12 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 30 30"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeWidth="2"
      d="M15 1a14 14 0 110 28 14 14 0 010-28z"
    />
    <path fill={color} d="M15 24.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeWidth="2"
      d="M10 11.667a5 5 0 118 4c-1.213.912-2.167 1-3 2.667"
    />
  </svg>
);

export default QuestionMarkIcon;
